module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CZ-21b31ba7bd1b9e6d1bcee5f33df08c6e.png";